
import createIcon from "./createIcon";

export const BookmarkIcon = createIcon('Bookmark', (props) => {
  return (
    <svg {...props}>
      <path d="M2,14.0568C2,14.8702,2.91937,15.3433,3.58124,14.8705L7.41876,12.1295C7.76646,11.8811,8.23354,11.8811,8.581240000000001,12.1295L12.4188,14.8705C13.0806,15.3433,14,14.8702,14,14.0568L14,2C14,1.447715,13.5523,1,13,1L3,1C2.447715,1,2,1.447715,2,2L2,14.0568ZM6.64572,11.0472L3.33,13.4156L3.33,2.33L12.67,2.33L12.67,13.4156L9.354289999999999,11.0472Q8.74668,10.61319,8,10.61319Q7.25332,10.61319,6.64572,11.0472Z" fillRule="evenodd" fill={props.color} fillOpacity="1" />
    </svg >
  )
});
